import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { parseData } from '@ups/xplat/utils';

const GET_MESSAGES = '/api/zipwhip/messages/{:number}/{:start}';
const GET_ATTACHMENT = '/api/zipwhip/attachment/{:storageKey}';
const SEND_MESSAGE = '/api/zipwhip/message/send';
const SAVE_CONTACT = '/api/zipwhip/contact/save';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  http: HttpClient;

  constructor(private httpFactory: MyHttpClientFactory) {
    this.http = httpFactory.createHttpClient(environment.urls.spartaAPI);
  }

  public getMessages(
    phoneNumber: string,
    startFrom: number = 0
  ): Promise<unknown> {
    let url = GET_MESSAGES.split('{:start}').join(startFrom.toString());
    url = url.split('{:number}').join(phoneNumber);
    return this.http.get(url).toPromise().then(parseData);
  }

  public getAttachemnt(storageKey: string): Promise<unknown> {
    const url = GET_ATTACHMENT.split('{:storageKey}').join(storageKey);
    return this.http.get(url).toPromise().then(parseData);
  }

  public sendMessage(
    sender: string,
    receiver: string,
    message: string
  ): Promise<unknown> {
    const item = {
      SenderPhone: sender,
      ReceiverPhones: [receiver],
      Body: message,
    };
    return this.http.post(SEND_MESSAGE, item).toPromise().then(parseData);
  }

  public saveContact(
    mobileNumber: string,
    firstName: string,
    lastName: string,
    email: string
  ): Promise<unknown> {
    const item = {
      MobileNumber: mobileNumber,
      FirstName: firstName,
      LastName: lastName,
      Email: email,
    };
    return this.http.post(SAVE_CONTACT, item).toPromise().then(parseData);
  }
}
